var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-view"},[(_vm.isInLobby)?_c('LobbyScreen'):[_c('TopBar',{attrs:{"is-in-call":_vm.isInCall}}),_vm._v(" "),(_vm.isInCall)?_c('CallView',{attrs:{"token":_vm.token}}):_c('ChatView'),_vm._v(" "),_c('PollViewer'),_vm._v(" "),(_vm.connectionFailed)?_c('CallFailedDialog',{attrs:{"token":_vm.token}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }